export default __webpack_public_path__ + "static/hosting-53dab0d2deb70676816fd66c2446d705.webm";